import api from '../api/client'

const base = (orgId) => `/organizadores/${orgId}/gestao`

export const gestaoService = {
  // ── Inicializar ────────────────────────────────────────────────────────────
  inicializar: (orgId) =>
    api.post(`${base(orgId)}/inicializar`),

  // ── Categorias ─────────────────────────────────────────────────────────────
  listarCategorias: (orgId, tipo) =>
    api.get(`${base(orgId)}/categorias`, { params: tipo ? { tipo } : {} }),
  criarCategoria: (orgId, dados) =>
    api.post(`${base(orgId)}/categorias`, dados),
  atualizarCategoria: (orgId, id, dados) =>
    api.put(`${base(orgId)}/categorias/${id}`, dados),
  verificarUsoCategoria: (orgId, id) =>
    api.get(`${base(orgId)}/categorias/${id}/uso`),
  excluirCategoria: (orgId, id) =>
    api.delete(`${base(orgId)}/categorias/${id}`),

  // ── Formas de Pagamento ────────────────────────────────────────────────────
  listarFormasPagamento: (orgId) =>
    api.get(`${base(orgId)}/formas-pagamento`),
  criarFormaPagamento: (orgId, dados) =>
    api.post(`${base(orgId)}/formas-pagamento`, dados),
  atualizarFormaPagamento: (orgId, id, dados) =>
    api.put(`${base(orgId)}/formas-pagamento/${id}`, dados),
  excluirFormaPagamento: (orgId, id) =>
    api.delete(`${base(orgId)}/formas-pagamento/${id}`),

  // ── Contas a Receber ───────────────────────────────────────────────────────
  listarContasReceber: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/contas-receber`, { params: filtros }),
  exportarContasReceberXlsx: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/contas-receber/exportar`, { params: filtros, responseType: 'blob', timeout: 60000 }),
  criarContaReceber: (orgId, dados) =>
    api.post(`${base(orgId)}/contas-receber`, dados),
  atualizarContaReceber: (orgId, id, dados) =>
    api.put(`${base(orgId)}/contas-receber/${id}`, dados),
  baixarContaReceber: (orgId, id, dados) =>
    api.post(`${base(orgId)}/contas-receber/${id}/baixar`, dados),
  estornarContaReceber: (orgId, id) =>
    api.post(`${base(orgId)}/contas-receber/${id}/estornar`),
  excluirContaReceber: (orgId, id) =>
    api.delete(`${base(orgId)}/contas-receber/${id}`),

  // ── Créditos de Cliente ────────────────────────────────────────────────────
  listarCreditosCliente: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/creditos-cliente`, { params: filtros }),
  marcarCreditoUtilizado: (orgId, id, dados) =>
    api.patch(`${base(orgId)}/creditos-cliente/${id}`, dados),
  relatorioCreditosClientePdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/creditos-cliente/relatorio/pdf`, { params: filtros, responseType: 'blob' }),

  // ── Contas a Pagar ─────────────────────────────────────────────────────────
  listarContasPagar: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/contas-pagar`, { params: filtros }),
  criarContaPagar: (orgId, dados) =>
    api.post(`${base(orgId)}/contas-pagar`, dados),
  atualizarContaPagar: (orgId, id, dados, scope = 'only') =>
    api.put(`${base(orgId)}/contas-pagar/${id}?scope=${scope}`, dados),
  baixarContaPagar: (orgId, id, dados) =>
    api.post(`${base(orgId)}/contas-pagar/${id}/baixar`, dados),
  estornarContaPagar: (orgId, id) =>
    api.post(`${base(orgId)}/contas-pagar/${id}/estornar`),
  excluirContaPagar: (orgId, id, scope = 'only') =>
    api.delete(`${base(orgId)}/contas-pagar/${id}?scope=${scope}`),

  // ── Dashboard ──────────────────────────────────────────────────────────────
  dashboard: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/dashboard`, { params: filtros }),

  // ── Notificações ──────────────────────────────────────────────────────────
  notificacoes: (orgId) =>
    api.get(`${base(orgId)}/notificacoes`),

  marcarNotificacoesLidas: (orgId) =>
    api.post(`${base(orgId)}/notificacoes/marcar-lidas`),

  // ── Sincronizar ────────────────────────────────────────────────────────────
  sincronizar: (orgId, leilaoId) =>
    api.post(`${base(orgId)}/sincronizar/${leilaoId}`),

  // ── Relatório ──────────────────────────────────────────────────────────────
  relatorio: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorios/contas`, { params: filtros }),

  // ── Relatórios PDF ─────────────────────────────────────────────────────────
  relatorioContasReceberPdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorio/contas-receber`, { params: filtros, responseType: 'blob' }),
  relatorioContasPagarPdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorio/contas-pagar`, { params: filtros, responseType: 'blob' }),
  relatorioGeralPdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorio/financeiro-geral`, { params: filtros, responseType: 'blob' }),
  relatorioCompradorVendedorPdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorio/comprador-vendedor`, { params: filtros, responseType: 'blob' }),
  relatorioRepassesVendedorPdf: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/relatorio/repasses-vendedor`, { params: filtros, responseType: 'blob' }),

  // ── Comprador x Vendedor — Parcelas de Negociação ──────────────────────────
  listarParcelasNegociacao: (orgId, filtros = {}) =>
    api.get(`${base(orgId)}/comprador-vendedor`, { params: filtros }),
  sincronizarParcelasNegociacao: (orgId, leilaoId) =>
    api.post(`${base(orgId)}/comprador-vendedor/sincronizar/${leilaoId}`),
  sincronizarTodasParcelas: (orgId) =>
    api.post(`${base(orgId)}/comprador-vendedor/sincronizar-todos`),
  darBaixaParcela: (orgId, parcelaId, dados) =>
    api.post(`${base(orgId)}/comprador-vendedor/${parcelaId}/baixa`, dados),
  darBaixaLote: (orgId, dados) =>
    api.post(`${base(orgId)}/comprador-vendedor/baixa-lote`, dados),
  estornarParcela: (orgId, parcelaId) =>
    api.post(`${base(orgId)}/comprador-vendedor/${parcelaId}/estornar`),

  // ── Repasses (Vendedor) ────────────────────────────────────────────────────
  darBaixaRepasse: (orgId, parcelaId, dados) =>
    api.post(`${base(orgId)}/comprador-vendedor/${parcelaId}/repasse`, dados),
  darBaixaRepasseLote: (orgId, dados) =>
    api.post(`${base(orgId)}/comprador-vendedor/repasse-lote`, dados),
  estornarRepasse: (orgId, parcelaId) =>
    api.post(`${base(orgId)}/comprador-vendedor/${parcelaId}/estornar-repasse`),

  // ── Comprovantes ───────────────────────────────────────────────────────────
  uploadComprovante: (orgId, parcelaIds, file) => {
    const form = new FormData()
    form.append('file', file)
    form.append('parcela_ids', JSON.stringify(parcelaIds))
    return api.post(`${base(orgId)}/comprador-vendedor/comprovantes`, form, {
      headers: { 'Content-Type': undefined },
    })
  },
  listarComprovantes: (orgId, parcelaId) =>
    api.get(`${base(orgId)}/comprador-vendedor/${parcelaId}/comprovantes`),
  excluirComprovante: (orgId, comprovanteId) =>
    api.delete(`${base(orgId)}/comprador-vendedor/comprovantes/${comprovanteId}`),

  // ── Comprovantes — Contas a Receber ────────────────────────────────────────
  listarComprovantesContaReceber: (orgId, contaId) =>
    api.get(`${base(orgId)}/contas-receber/${contaId}/comprovantes`),
  uploadComprovanteContaReceber: (orgId, contaId, file) => {
    const form = new FormData()
    form.append('file', file)
    return api.post(`${base(orgId)}/contas-receber/${contaId}/comprovantes`, form, {
      headers: { 'Content-Type': undefined },
    })
  },

  // ── Comprovantes — Contas a Pagar ──────────────────────────────────────────
  listarComprovantesContaPagar: (orgId, contaId) =>
    api.get(`${base(orgId)}/contas-pagar/${contaId}/comprovantes`),
  uploadComprovanteContaPagar: (orgId, contaId, file) => {
    const form = new FormData()
    form.append('file', file)
    return api.post(`${base(orgId)}/contas-pagar/${contaId}/comprovantes`, form, {
      headers: { 'Content-Type': undefined },
    })
  },

  // ── Configurações da Gestão ────────────────────────────────────────────────
  obterConfiguracoes: (orgId) =>
    api.get(`${base(orgId)}/configuracoes`),
  atualizarConfiguracoes: (orgId, dados) =>
    api.put(`${base(orgId)}/configuracoes`, dados),
}

